import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Icon } from '../components/Icon';
import { api } from '../lib/api';
import { money } from '../lib/format';
import { useSession } from '../lib/session';
import type { Deal } from './Deals';
import '../styles/deals.css';

export function Logistics() {
  const { company } = useSession();
  const nav = useNavigate();
  const [deals, setDeals] = useState<Deal[] | null>(null);

  useEffect(() => {
    if (!company) return;
    setDeals(null);
    api.get<Deal[]>('/deals').then(setDeals).catch(() => setDeals([]));
  }, [company]);

  const shipments = (deals ?? []).filter((d) => d.origin || d.destination);

  return (
    <main className="main">
      <div className="page-head">
        <div className="page-head__title">
          <span className="eyebrow">Operaciones</span>
          <h1 className="h1">Logistics</h1>
          <p className="page-head__sub">The physical movement of deals: origin, destination and incoterm of each shipment in progress.</p>
        </div>
      </div>

      {!deals && <div className="faint" style={{ padding: 40 }}>Loading…</div>}
      {deals && shipments.length === 0 && (
        <div className="card"><div className="empty">No shipments with a defined route. Shipments appear when you set origin and destination on a deal.</div></div>
      )}

      <div className="col gap-12">
        {shipments.map((d) => (
          <div key={d.id} className="card">
            <div className="card__body">
              <div className="row between center" style={{ marginBottom: 14 }}>
                <div>
                  <div className="deal-card__code">{d.code}</div>
                  <div style={{ fontWeight: 600, fontSize: 14, marginTop: 2 }}>{d.title}</div>
                </div>
                <button className="btn btn--ghost btn--sm" onClick={() => nav(`/operaciones/${d.id}`)}>Open deal<Icon name="arrow-right" size={14} /></button>
              </div>
              <div className="route-line">
                <div className="route-node">
                  <div className="route-node__label">Origen</div>
                  <div className="route-node__place">{d.origin ?? '—'}</div>
                </div>
                <div className="route-track"><span className="route-track__ico"><Icon name="route" size={18} /></span></div>
                <div className="route-node">
                  <div className="route-node__label">Destino</div>
                  <div className="route-node__place">{d.destination ?? '—'}</div>
                </div>
                {d.incoterm && <span className="route-incoterm">{d.incoterm}</span>}
              </div>
              <div className="row between center" style={{ marginTop: 14, paddingTop: 12, borderTop: '1px solid var(--line)' }}>
                <span className="pill pill--muted"><span className="pill__dot" />{d.stageLabel}</span>
                <span className="num" style={{ fontWeight: 600 }}>{money(d.valueMinor, d.currency)}</span>
              </div>
            </div>
          </div>
        ))}
      </div>
    </main>
  );
}
